import { useTranslation } from 'react-i18next';

export interface FaqItem {
  q: string;
  a: string;
}

/** Lit les items FAQ depuis i18next (FR/EN). Réutilisable pour rendu UI + JSON-LD SEO. */
export function useFaqItems(): FaqItem[] {
  const { t } = useTranslation('marketing');
  const items = t('home.faqItems', { returnObjects: true });
  return Array.isArray(items) ? (items as FaqItem[]) : [];
}
